import styled from '@mui/material/styles/styled';
import Button from '@mui/material/Button';

// Details
export const Root = styled('div')(() => ({
  width: '100%',
  height: '100%',
}));

export const Header = styled('div')(({ theme }) => ({
  width: '100%',
  height: theme.app.tool.headerHeight,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: theme.palette.background.paper,
  borderBottom: `1px solid ${theme.palette.border}`,
  padding: '8px 16px',
}));

export const HeaderButton = styled(Button)(() => ({
  fontSize: '1.15rem',
  lineHeight: 1,
  minWidth: 'unset',
  fontWeight: 700,
  padding: '4px',
}));


export const Wrapper = styled('div')(({ theme }) => ({
  width: '100%',
  height: `calc(100% - ${theme.app.tool.headerHeight})`,
  display: 'flex',
}));
